import { Analytics } from '.';

if (!window.tracked) {
  window.tracked = {};
}

export const BOT_STATUS = {
  OPEN: 'bot open',
  CLOSE: 'bot close'
};

export const brandlinksClick = e => {
  Analytics.setTrackingData({
    [Analytics.keys.linkInformation(0)]: `Brand Change: ${e.target.outerText}`,
    [Analytics.keys.eventTargetURL()]: `${e.target.href}`,
    [Analytics.keys.eventType(0)]: 'interAction',
    [Analytics.keys.eventAction(0)]: 'Success'
  });
  Analytics.trackInteraction();
};

export const accordionClick = e => {
  const value =
    e.target.querySelector('.c-accordion__title-label-text') ||
    e.target.closest('.c-accordion__title-label-text') ||
    e.target.parentElement.closest('.c-accordion__title-label-text') ||
    e.target.parentElement.querySelector('.c-accordion__title-label-text');
  const parent = e.target.closest('.c-accordion__header');

  if (
    window.tracked[value.innerText] ||
    (parent && parent.nextSibling.getAttribute('aria-hidden') === 'false')
  ) {
    window.tracked[value.innerText] = false;
    return;
  }
  window.tracked[value.innerText] = true;
  Analytics.trackAccordion(`Info: ${value.innerText}`, `Info: ${value.innerText}`);
};

window.lastCall = 0;
window.delay = 20;

export const delay = () => {
  if (window.lastClick >= Date.now() - window.delay) return;
  window.lastClick = Date.now();
};

export const openBot = () => {
  if (window.tracked[BOT_STATUS.OPEN]) {
    return;
  }
  window.tracked[BOT_STATUS.OPEN] = true;
  window.tracked[BOT_STATUS.CLOSE] = false;

  Analytics.setTrackingData({
    [Analytics.keys.linkInformation(0)]: 'Bot Interaction: Bot opened',
    [Analytics.keys.eventType(0)]: 'interAction',
    [Analytics.keys.eventAction(0)]: 'Success',
    [Analytics.keys.eventType(1)]: 'Bot',
    [Analytics.keys.eventAction(1)]: 'Opened'
  });
  Analytics.trackInteraction();
};

export const closeBot = () => {
  if (window.tracked[BOT_STATUS.CLOSE]) {
    return;
  }
  window.tracked[BOT_STATUS.OPEN] = false;
  window.tracked[BOT_STATUS.CLOSE] = true;

  Analytics.setTrackingData({
    [Analytics.keys.linkInformation(0)]: 'Bot Interaction: Bot closed',
    [Analytics.keys.eventType(0)]: 'interAction',
    [Analytics.keys.eventAction(0)]: 'Success',
    [Analytics.keys.eventType(1)]: 'Bot',
    [Analytics.keys.eventAction(1)]: 'Closed'
  });
  Analytics.trackInteraction();
};

export const messageBot = () => {
  if (Object.keys(window.tracked).length === 0) {
    setTimeout(() => {
      Analytics.setTrackingData({
        [Analytics.keys.linkInformation(0)]: 'Bot Interaction: Message sent',
        [Analytics.keys.eventType(0)]: 'interAction',
        [Analytics.keys.eventAction(0)]: 'Success',
        [Analytics.keys.eventType(1)]: 'Bot',
        [Analytics.keys.eventAction(1)]: 'Message sent'
      });
      Analytics.trackInteraction();
    }, 500);
  } else {
    Analytics.setTrackingData({
      [Analytics.keys.linkInformation(0)]: 'Bot Interaction: Message sent',
      [Analytics.keys.eventType(0)]: 'interAction',
      [Analytics.keys.eventAction(0)]: 'Success',
      [Analytics.keys.eventType(1)]: 'Bot',
      [Analytics.keys.eventAction(1)]: 'Message sent'
    });
    Analytics.trackInteraction();
  }
};

export const continue1Click = () => {
  Analytics.trackContinueButton(
    'Product configured',
    {
      type: 'interAction',
      action: 'Success'
    },
    {
      type: 'Product price',
      action: 'Calculated'
    },
    {
      type: 'Product configuration',
      action: 'Completed'
    }
  );
};

export const continue2Click = () => {
  Analytics.trackContinueButton(
    'Product configured',
    {
      type: 'interAction',
      action: 'Success'
    },
    {
      type: 'ProductInformation:Personal Information',
      action: 'Provided'
    },
    {
      type: 'ProductInformation:Contact Information',
      action: 'Provided'
    },
    {
      type: 'ProductInformation:Vehicle Information',
      action: 'Provided'
    }
  );
};
// Requested by Adobe team to not use the Start typing calls as of 17.02.2023
// export const firstCustomerInteraction = (item, e) => {
//   if (window.tracked[e.target.name]) {
//     return
//   }
//   window.log(e.target.name)
//   window.tracked[e.target.name] = true

//   Analytics.trackFirstInteraction()
//   item.removeEventListener('blur', firstCustomerInteraction)
// }

// export const zipFormFieldInteraction = (item, e) => {
//   window.log(e.target.name)
//   window.tracked[e.target.name] = true

//   Analytics.trackZipFormFieldInteraction()
//   item.removeEventListener('blur', zipFormFieldInteraction)
// }

export const errorSituation = errors => {
  Analytics.trackError(errors);
};

export const buttonClick = (value, e) => {
  delay();

  switch (value) {
    case BUTTONS.EDIT: {
      if (typeof e === 'string') {
        Analytics.trackButton(`Edit ${e}`);
      } else {
        const val =
          e.target.querySelector('.c-data-overview__title') ||
          e.target.closest('.c-data-overview__title') ||
          e.target.parentElement.parentElement.closest('.c-data-overview__title') ||
          e.target.parentElement.parentElement.querySelector('.c-data-overview__title');
        Analytics.trackButton(`Edit ${val.innerText}`);
      }
      break;
    }
    case BUTTONS.ISSUE_SEPA:
      Analytics.trackButton('Issue SEPA mandate');
      break;
    case BUTTONS.SEPA_DOC:
      Analytics.trackButton('Download SEPA mandate');
      break;
    case BUTTONS.DOWNLOAD: {
      const val = e.target;
      Analytics.downloadDocument(`Download ${val.innerText}`);
      break;
    }
    default:
      Analytics.trackButton();
  }
};

export const continue3Click = () => {
  Analytics.trackContinueButton(
    '',
    {
      type: 'Payment data',
      action: 'Provided'
    },
    {
      type: 'RequiredContractData',
      action: 'Provided'
    }
  );
};

export const continue4Click = () => {
  Analytics.trackContinueButton('Summary', {
    type: 'interAction',
    action: 'Success'
  });
};

export const BUTTONS = {
  EDIT: 'edit',
  ISSUE_SEPA: 'Issue SEPA',
  SEPA_DOC: 'SEPA Mandate',
  DOWNLOAD: 'Download',
  STEP1: 'Step1Continue',
  STEP2: 'Step2Continue',
  STEP3: 'Step3Continue'
};
